import { useState } from 'react'

import { AppStoreBadge, GooglePlayStoreBadge } from '../../shared/components/AppDownloadBadge'

import TextButton from './TextButton'
import '../styles/header.scss'

const GetAppButton = () => (
    <TextButton className="nav-get-app-btn">
        <T>get.app.title</T>
        <div className="nav-ic-down-arrow" />
    </TextButton>
)

const GetAppDropdown = () => (
    <div className="getAppDropdownWrap">
        <div className="arrow-box">
            <AppStoreBadge imgClass="nav-ic-download" />
            <div className="spacing" />
            <GooglePlayStoreBadge imgClass="nav-ic-download" />
        </div>
    </div>
)

const GetAppContainer = () => {
    const [isDropdownActive, setIsDropdownActive] = useState(false)

    const toggleDropdown = () => setIsDropdownActive(prev => !prev)

    return (
        <div className="nav-get-app-container" onMouseEnter={toggleDropdown} onMouseLeave={toggleDropdown}>
            <GetAppButton />
            {isDropdownActive && <GetAppDropdown />}
        </div>
    )
}

export default GetAppContainer
